export function inventoryAmountIssues(max: number | null, avg: number | null, requireAmounts = true): string[] {
  const issues: string[] = [];
  for (const [name, value] of [
    ['Maximum', max],
    ['Average', avg],
  ] as const) {
    if (value == null) {
      if (requireAmounts) issues.push(`${name} amount is required.`);
    } else if (!Number.isFinite(value) || value < 0) issues.push(`${name} amount must be finite and nonnegative.`);
  }
  if (max != null && avg != null && avg > max) issues.push('Average amount cannot exceed maximum amount.');
  return issues;
}

/** Empty and partially known groups cannot produce a complete reported total. */
export function sumKnownAmounts(values: (number | null)[]): number | null {
  if (!values.length || values.some((value) => value == null)) return null;
  return values.reduce<number>((sum, value) => sum + value!, 0);
}
